export default __webpack_public_path__ + "static/media/1226.b1288061.png";